import { usePermissions } from '@customerio/hydra-permissions/react';
import type { AddFundsAction, CreditsState, CreditsUsage } from '@/features/billing-usage';
import type { CreditsPurchasePageName } from '../utils/credits-purchase-page-name';
import { flexAddFundsAction } from '../utils/flex-add-funds';
import { useBillingLandingHref } from './use-billing-landing-href';
import { useCreditPurchase } from './use-credit-purchase';
import { useCreditsSummary } from './use-credits-summary';

export type FlexCreditsPanel = {
  state: CreditsState;
  balanceCents: number;
  topUpBalanceCents: number;
  lastTopUpCents: number;
  usage: CreditsUsage;
  billingHref: string | null;
  addFunds: AddFundsAction;
};

export function useFlexCreditsPanel(pageName: CreditsPurchasePageName): FlexCreditsPanel | null {
  const summary = useCreditsSummary();
  const billingLandingHref = useBillingLandingHref();
  const { hasPermission } = usePermissions();
  const purchase = useCreditPurchase({ pageName });

  if (summary.status !== 'ready') return null;

  return {
    state: summary.state,
    balanceCents: summary.balanceCents,
    topUpBalanceCents: summary.topUpBalanceCents,
    lastTopUpCents: summary.lastTopUpCents,
    usage: summary.usage,
    // Without billing view, the billing route sends the member back to settings. Hide the link.
    billingHref: hasPermission('account/billing/view') === true ? billingLandingHref : null,
    addFunds: flexAddFundsAction(purchase, summary.hasFunded),
  };
}
